import { module } from 'modujs';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import { ENV } from '../config.js';

export default class extends module {
    constructor(m) {
        super(m);
        // this.minHeight = null;

        this.nav = this.el.querySelector('.m-before-after_nav');
        this.itemsWrap = this.el.querySelector('.m-before-after_items');
        
        this.events = {
            click: {
                changeState: 'changeState'
            }
        }
    }

    changeState(e) {
        let state = e.currentTarget.getAttribute('data-state');

        this.nav.querySelectorAll('span').forEach((elt) => {
            if (elt.classList.contains('-active')) {
                elt.classList.remove('-active');
            }
            if (elt.getAttribute('data-state') == state) {
                elt.classList.add('-active');
            }
        });

        this.itemsWrap.setAttribute('data-state', state);
    }

    start() {
        let state = "after";

        this.nav.querySelectorAll('span').forEach((elt) => {
            if (elt.classList.contains('-active')) {
                elt.classList.remove('-active');
            }
            if (elt.getAttribute('data-state') == state) {
                elt.classList.add('-active');
            }
        });

        this.itemsWrap.setAttribute('data-state', state);
    }
}
